import { Box, Typography } from '@mui/material';
import useResponsive from 'utils/CustomHooks/useResponsive';
import { ContentWrapper, CustomModalWrapper } from './style';
import VideoCamRecorder from 'components/VideoCamRecorder';
import CloseIcon from '@mui/icons-material/Close';

const RecordVideo = ({ open, successCallback, handleClose }) => {
  const { isMobileDeviceSm } = useResponsive();

  const uploadHandlerCallback = (videoInfo: any) => {
    successCallback?.(videoInfo);
    handleClose?.();
  };

  return (
    <CustomModalWrapper
      smallScreen={isMobileDeviceSm}
      handleClose={handleClose}
      open={open}
      fullScreen={isMobileDeviceSm}
    >
      <ContentWrapper gap="20px">
        <Box className="header">
          <Typography className="title">Record Video</Typography>
          <CloseIcon
            onClick={handleClose}
            sx={{ fontSize: '22px', cursor: 'pointer', color: '#1C1B1F' }}
          />
        </Box>
        <Box className="content">
          <VideoCamRecorder uploadHandlerCallback={uploadHandlerCallback} />
        </Box>
      </ContentWrapper>
    </CustomModalWrapper>
  );
};

export default RecordVideo;
